/* eslint-disable no-new */
import hamburger from './modules/hamburger.js';
import videoPlayer from './modules/videoPlayer.js';
import hoverMenuItem from './modules/hoverMenuItem.js';
import videoIcon from './modules/videoIcon.js';
import formLabel from './modules/formLabel.js';
import fixedHeader from './modules/fixedHeader.js';
document.addEventListener( 'DOMContentLoaded', () => {
	hamburger();
  videoPlayer();
  hoverMenuItem();
  videoIcon();
  formLabel();
  fixedHeader();
} );

